module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"title":"beauty pass tiers"},"lng_id":{"title":"Tingkatan Beauty Pass"},"lng_th":{"title":"ระดับสมาชิกบิวตี้พาส"},"lng_zh":{"title":"Beauty Pass會籍"},"lng_ko":{"title":"뷰티 패스 등급"}}')
  delete Component.options._Ctor
}
